import React from 'react';
import EnablingFeature from '../../../components/EnablingFeature';
import { Outlet } from 'react-router-dom';

const SettingsContainer = () => {
    return (
        <EnablingFeature flag='Accessible'>
            <div className='lg:mt-[15px] mt-[30px] lg:space-y-[15px] space-y-2 '>
                <div className='lg:text-[24px] lg:font-medium font-normal flex justify-between text-[20px] px-4 lg:px-0 lg:text-[#475467] text-black'>
                    Settings
                </div>
                <Outlet />
            </div>
        </EnablingFeature>
    );
};

export default SettingsContainer;
